import { theme, type ThemeConfig } from 'antd';
import { colors, radius, chartTheme, IS_DARK } from './designTokens';

// Claude 風格 — 溫暖淺色主題
export const darkThemeConfig: ThemeConfig = {
  // 深色風格用 antd 深色演算法（輸入框、下拉、彈窗、表格等元件內建深色），再疊上本系統色碼
  algorithm: IS_DARK ? theme.darkAlgorithm : theme.defaultAlgorithm,
  token: {
    colorPrimary: colors.primary,
    colorBgContainer: colors.bgWhite,
    colorBgElevated: colors.bgWhite,
    colorBgLayout: colors.bgLayout,
    colorBorder: colors.border,
    colorText: colors.text,
    colorTextSecondary: colors.textSecondary,
    borderRadius: radius.lg,
    colorLink: colors.primary,
  },
  components: {
    Layout: {
      siderBg: colors.bgSider,
      headerBg: colors.bgWhite,
      bodyBg: colors.bgLayout,
    },
    Card: {
      colorBgContainer: colors.bgWhite,
    },
    Table: {
      colorBgContainer: colors.bgWhite,
      headerBg: colors.bgTableHeader,
    },
    Menu: {
      itemBg: 'transparent',
      subMenuItemBg: 'transparent',
      itemSelectedBg: colors.primaryHover,
      itemSelectedColor: colors.primary,
      itemHoverBg: colors.primarySubtle,
    },
    Button: {
      primaryColor: '#FFFFFF',   // 主色按鈕字固定白色（深色風格 bgWhite 是深底色）
    },
  },
};

// Recharts 圖表色值（淺色背景）— re-export from designTokens
export const CHART_DARK = chartTheme;
